import { LanguageCode } from "@vana/core";
import es_GT from "./es_GT.json";

export const translations = {
  [LanguageCode.ES_GT]: { ...es_GT },
};
